((holidayBundleProduct, $) => {
  'use strict';

  const $dom = {};

  let settings = {};
  let holidyBundleProducts = {};

  const cacheDom = () => {
    $dom.productJSON = $('#ProductJson-product-template');
    $dom.productOptions = $('.purchase-box');

    $dom.promoBar = $('.promos');
    $dom.mobileHeader = $('header');
    $dom.desktopHeader = $('.header');

    $dom.productTitleVariant = $('.js-product-title-variant');
    $dom.productVariantSelector = $('.js-product-variant-selector');

    $dom.productFeaturedSlider = $('.js-product-featured-slider');
    $dom.productImageSlider = $('.js-product-thumbnails-slider');
  };

  const initBundleProductObj = () => {
    $('.js-holiday-bundle-form').each((idx, obj) => {
      const product_id = $(obj).data('product-id');
      const product_js = $(obj).data('js');
      holidyBundleProducts[product_id] = holidyBundleProducts[product_id] || {};
      holidyBundleProducts[product_id].productJSON = product_js;
    });
  }

  const initCustomizerTitle = () => {
    let source = [];

    const price = source[0];
    const desc = source[1];
  }

  const unselectThumbnails = () => {
    $('.js-product-images-thumbnail-link.active').removeClass('active');
  };

  const initSettings = () => {
    $('.js-product-variant-option-selector').each(function() {
      const product_id = $(this).closest('.js-holiday-bundle-form').data('product-id');
      const optionName = $(this).data('name');
      const optionNum = $(this).data('option');
      const value = $(this).val();
      settings[product_id] = settings[product_id] || {};
      settings[product_id][optionNum] = {
        "name" : optionName,
        "value" : value
      };
    });
  };

  const initDisabledSizes = () => {
    $('.js-holiday-bundle-form').each((idx, obj) => {
      const $form = $(obj);
      const product_id = $form.data('product-id');
      const keys = Object.keys(holidayBundleProduct.settings[product_id]);
      const nonSizeOptionKeys = keys.filter((key) => holidayBundleProduct.settings[product_id][key] && holidayBundleProduct.settings[product_id][key].name.toString().toLowerCase() != "size");
      const sizeOptionKeys = keys.filter((key) => holidayBundleProduct.settings[product_id][key] && holidayBundleProduct.settings[product_id][key].name.toString().toLowerCase() == "size");

      if (sizeOptionKeys.length > 0) {
        const sizeOption = sizeOptionKeys[0];
        const productVariants = holidyBundleProducts[product_id].productJSON.variants;
        const matchingVariants = productVariants.filter((variant) => {
          for (let i = 0; i < nonSizeOptionKeys.length; i++) {
            if (variant[nonSizeOptionKeys[i]].toString().toLowerCase() !== settings[product_id][nonSizeOptionKeys[i]].value.toString().toLowerCase()) {
              return false;
            }
          }
          return true;
        });

        $form.find('.js-product-variant-size').each(function() {
          $(this).removeClass('is-disabled');
          let $that = $(this);
          const matchingSizeVariant = matchingVariants.filter((variant) => {
            if (variant[sizeOption].toString().toLowerCase() === $that.data('value').toString().toLowerCase()) {
              return true;
            }
          });
          if (matchingSizeVariant.length < 1 || (matchingSizeVariant.length > 0 && !(matchingSizeVariant[0].available))) {
            $(this).addClass('is-disabled');
            if ($(this).hasClass('is-active')) {
              $(this).removeClass('is-active');
            }
          } else if ($(this).data('value').toString().toLowerCase() === settings[product_id][sizeOption].value.toString().toLowerCase()) {
            $(this).addClass('is-active');
          }
        });

        $form.find('.js-product-variant-size.is-disabled').each(function() {
          const $before = $(this).find('.product--variant-size-disabled-before');
          const $after = $(this).find('.product--variant-size-disabled-after');
          const opposite = $(this).outerHeight();
          const adjacent = $(this).outerWidth();
          const deg = Math.atan(opposite / adjacent) * (180 / Math.PI);
          $before.css({"transform" : `skewY(${deg}deg)`});
          $after.css({"transform" : `skewY(-${deg}deg)`});
        });
      }
    });
  };

  const changeVariantOption = ($that) => {
    if (!($that.hasClass('is-active') || $that.hasClass('is-disabled'))) {
      const $displayList = $that.closest('.product--variant-display-list');
      const $form = $that.closest('.js-holiday-bundle-form');
      const $selectList = $form.find(`.js-product-variant-option-selector[data-name='${$displayList.data('name')}']`);
      $selectList.find('option').each(function() {
        if ($(this).val().toString().toLowerCase() === $that.data('value').toString().toLowerCase()) {
          $selectList.val($(this).val()).change();
          return false;
        }
      });

      $displayList.find('.is-active').removeClass('is-active');
      $that.addClass('is-active');

    }
  };

  const filterVariants = () => {
    $('.js-holiday-bundle-form').each((idx, obj) => {
      const $form = $(obj);
      const product_id = $form.data('product-id');

      let tempArray = holidyBundleProducts[product_id].productJSON.variants.slice();
      Object.keys(settings[product_id]).forEach(key => {
        tempArray = tempArray.filter(variant => {
          return variant[key] === settings[product_id][key].value;
        });
      });
      if (tempArray.length == 1) {
        const currentVariant = tempArray[0];
        if (currentVariant.available) {
          /* CHANGE ATC CTA TO ACTIVE
          $(".js-quickview-atc-button")
            .prop("disabled", false)
            .removeClass("disabled");
          $(".js-quickview-atc-button-text").html("Add to Cart");*/
          $form.find(".js-product-variant-selector")
            .val(currentVariant.id)
            .change();
        } else {
          /* CHANGE ATC CTA TO SOLD OUT
          $(".js-quickview-atc-button")
            .prop("disabled", true)
            .addClass("disabled");
          $(".js-quickview-atc-button-text").html("Sold Out");*/
        }
      }
    });
  };

  const bindUIActions = () => {
    $(window).on('resize', function() {
      initDisabledSizes();
    });

    $('.js-product-variant-display-value').on('click', function() {
      changeVariantOption($(this));
    });

    $('[data-name="Color"] .js-product-variant-display-value').on('mouseenter', function() {
      $(this).closest('.product--variant-display-option').find('.js-product-current-variant-option').text($(this).data('value'));
    });

    $('.holiday-bundle-travel-kit--main-container [data-name="Color"] .js-product-variant-display-value').on('mouseout', function() {
      const product_id = $(this).closest('.js-holiday-bundle-form').data('product-id');
      const optionNum = $(this).closest('.product--variant-display-list').data('option');
      $(this).closest('.product--variant-display-option').find('.js-product-current-variant-option').text(settings[product_id][optionNum].value);
    });

    $('.test-product [data-name="Color"] .js-product-variant-display-value').on('mouseout', function() {
      const optionNum = $(this).closest('.product--variant-display-list').data('option');
      $(this).closest('.product--variant-display-option').find('.js-product-current-variant-option').text($(this).data('value'));
    });

    $('.js-product-variant-option-selector').on('change', function() {
      const $form = $(this).closest('.js-holiday-bundle-form');
      const product_id = $form.data('product-id');
      const optionName = $(this).data('name');
      const optionNum = $(this).data('option');
      const value = $(this).val();
      settings[product_id][optionNum].value = value;
      $form.find(`.js-product-current-variant-option[data-name=${optionName}]`).text(value.charAt(0).toUpperCase() + value.slice(1));
      initDisabledSizes();
      filterVariants();
    });
  };

  const init = () => {
    cacheDom();
    initBundleProductObj();
    initSettings();
    initCustomizerTitle();
    initDisabledSizes();
    bindUIActions();
  };

  holidayBundleProduct.init = init;
  holidayBundleProduct.settings = settings;
  holidayBundleProduct.holidyBundleProducts = holidyBundleProducts;
})(window.holidayBundleProduct = window.holidayBundleProduct || {}, jQuery);
